import Phaser from 'phaser'
import MovingObjectComponent from '../components/movingObjectComponent'
import PositionEditor from '../editor/positionEditor'

export default class Editable extends Phaser.GameObjects.Container {
  constructor (scene, args, typeName, doSave = true) {
    super(scene)
    this.scene = scene
    this.typeName = typeName
    this.doSave = doSave
    this.children = []
    this.bounce = true
    this.lethal = false
    this.bounceMP = 1
    this.id = args.id || -1
    this.parentId = args.parentId || -1
    this.parentOffsetX = args.offsetX || 0
    this.parentOffsetY = args.offsetY || 0

    // console.log('spawned something with id: ' + this.id)

    this.handles = []
    this.editableVars = [] // this holds all the saveable variables that can be editted using the editor GUI
    this.hiddenVars = [] // this holds all the saveable variables that are editted indirectly (through handlers)
    this.components = [] // add components to this list to make sure they get: -updated, -deleted

    this.addHiddenProperty('x', () => { return Math.round(this.getX()) })
    this.addHiddenProperty('y', () => { return Math.round(this.getY()) })
    this.addHiddenProperty('id', () => { return this.id })
    this.addHiddenProperty('parentId', () => { return this.parentId })
    this.addHiddenProperty('offsetX', () => { return this.parentOffsetX })
    this.addHiddenProperty('offsetY', () => { return this.parentOffsetY })

    this.parentLine = this.scene.add.image(0, 0, 'images', 'finish')
    this.parentLine.setOrigin(0.5, 1)
    this.parentLine.setDepth(100)
    // this.refreshParentLine()
    this.parentLine.setVisible(false)
  }

  init (args, canMove, showCorners = false) {
    // All editables have a positionEditor:
    this.positionEditor = new PositionEditor(this.scene, this)
    this.addEditor(this.positionEditor)

    // Only editables that can (at some point) move, have a movingObjectComponent+Editor
    if (canMove) {
      this.moveComponent = new MovingObjectComponent(this.scene, this, args, showCorners)
      this.isMoving = args.isMoving || false
      this.image.body.moves = this.isMoving
      this.addEditableProperty('isMoving', (value) => { this.setMoving(value) }, () => { return this.isMoving })
      if (this.isMoving) {
        this.addComponent(this.moveComponent)
      }
    }
  }

  preUpdate (time, delta) {
    for (var i = 0; i < this.components.length; i++) {
      this.components[i].update(time, delta)
    }

    if (this.parent) {
      this.image.x = this.parent.image.x + this.parentOffsetX
      this.image.y = this.parent.image.y + this.parentOffsetY
    }
  }

  addComponent (component) {
    this.components.push(component)
    component.enable()
  }

  removeComponent (component) {
    var index = this.components.indexOf(component)
    this.components.splice(index, 1)
    component.disable()
  }

  addEditableProperty (key, setter, getter) {
    this.editableVars.push({ key, setter, getter })
  }

  addHiddenProperty (key, getter) {
    this.hiddenVars.push({ key, getter })
  }

  removeProperty (key) {
    var index = this.editableVars.findIndex(element => element.key === key)
    if (index >= 0) {
      this.editableVars.splice(index, 1)
    } else {
      index = this.hiddenVars.findIndex(element => element.key === key)
      this.hiddenVars.splice(index, 1)
    }
  }

  addEditor (editor) {
    this.handles.push(editor)
  }

  removeEditor (editor) {
    var index = this.handles.indexOf(editor)
    this.handles.splice(index, 1)
    editor.hideHandlers()
  }

  getValue (key) {
    return this.editableVars[key].getter()
  }

  setValue (key, value) {
    var index = this.editableVars.findIndex(p => p.key === key)
    this.editableVars[index].setter(value)
  }

  setMoving (value) {
    if (!this.isMoving && value) {
      this.moveComponent.p0 = new Phaser.Math.Vector2(this.image.x, this.image.y)
      this.moveComponent.p1 = new Phaser.Math.Vector2(this.image.x + 500, this.image.y)
      this.addComponent(this.moveComponent)
      this.moveComponent.startEdit()
      this.showEditing()
    } else if (this.isMoving && !value) {
      this.removeComponent(this.moveComponent)
    }

    this.isMoving = value
    this.image.body.moves = this.isMoving
    this.refreshMoving()
  }

  addChild (child) {
    this.children.push(child)
  }

  removeChild (child) {
    var index = this.children.indexOf(child)
    if (index > -1) {
      this.children.splice(index, 1)
    }
  }

  attachTo (parent, offsetX, offsetY) {
    this.parent = parent
    this.parentId = parent.id

    this.image.x = this.parent.image.x + offsetX
    this.image.y = this.parent.image.y + offsetY

    this.parentOffsetX = this.image.x - parent.image.x
    this.parentOffsetY = this.image.y - parent.image.y
    this.parent.addChild(this)
  }

  detachFromParent () {
    this.parent.removeChild(this)
    this.parent = null
    this.parentId = -1
    this.onEdit()
  }

  showEditing () {
    if (!this.doSave) {
      return
    }

    for (var h = 0; h < this.handles.length; h++) {
      this.handles[h].showHandlers()
    }

    this.refreshParentLine()
    this.refreshMoving()
  }

  hideEditing () {
    for (var h = 0; h < this.handles.length; h++) {
      this.handles[h].hideHandlers()
    }

    this.parentLine.setVisible(false)
  }

  drawParentLine (x, y) {
    this.parentLine.setVisible(true)
    this.parentLine.x = this.image.x
    this.parentLine.y = this.image.y
    var len = Math.sqrt(Math.pow(x - this.image.x, 2) + Math.pow(y - this.image.y, 2))
    this.parentLine.setDisplaySize(10, Math.abs(len))// this.parent.image.y - this.image.y))// this.range)

    var diff = new Phaser.Math.Vector2(x, y)
    var p0 = new Phaser.Math.Vector2(this.image.x, this.image.y)
    diff.subtract(p0)
    var angle = diff.angle()
    this.parentLine.setRotation(angle + (Math.PI * 0.5))
  }

  refreshParentLine () {
    if (this.parent) {
      this.drawParentLine(this.parent.image.x, this.parent.image.y)
    } else {
      this.parentLine.setVisible(false)
    }
  }

  onEdit () {
    if (this.parent) {
      this.parentOffsetX = this.image.x - this.parent.image.x
      this.parentOffsetY = this.image.y - this.parent.image.y
    }

    for (var i = 0; i < this.children.length; i++) {
      this.children[i].refreshHandlers()
    }

    this.refreshHandlers()
    this.refreshMoving()
  }

  onHit () {
    // ..
  }

  makeEasier () {
    // ..
  }

  refreshHandlers () {
    for (var i = 0; i < this.handles.length; i++) {
      this.handles[i].refreshHandlerPositions()
    }

    this.refreshParentLine()
  }

  refreshMoving () {
    if (this.moveComponent && this.isMoving) {
      this.moveComponent.refreshPath(new Phaser.Math.Vector2(this.image.x, this.image.y), this.moveComponent.p1)
    }
  }

  delete () {
    if (this.image) {
      this.image.destroy()
    }
    for (var i = 0; i < this.handles.length; i++) {
      this.handles[i].delete()
    }
    for (i = 0; i < this.components.length; i++) {
      this.components[i].delete()
    }
    if (this.parentLine) {
      this.parentLine.destroy()
    }
    this.destroy()
  }

  toDef () {
    var def = {}
    def.type = this.typeName
    def.data = {}
    for (var i = 0; i < this.editableVars.length; i++) {
      var key = this.editableVars[i].key
      var value = this.editableVars[i].getter()
      def.data[key] = value
    }
    for (i = 0; i < this.hiddenVars.length; i++) {
      key = this.hiddenVars[i].key
      value = this.hiddenVars[i].getter()
      def.data[key] = value
    }
    return def
  }

  getX () {
    return this.image.x
  }

  getY () {
    return this.image.y
  }
}
